<template lang="pug">
v-expansion-panel.elevation-0
  v-expansion-panel-content(v-for='lopt in leaseOptionsForProductType', :key='lopt._id')
    v-layout(align-center, justify-space-between, slot='header')
      div
        transition(name='fade', mode='out-in')
          v-icon.mr-3(v-if='lopt.enabled' color='green', key='enabled') fa fa-check
          v-icon.mr-3(v-else, key='disabled') fa fa-ban
        span {{ lopt.label }}

      pricing-dialog.mr-4(
        :title='lopt.label',
        :header='["Soort", "Kosten per aanvraag"]'
        :items='[{ name: lopt.label, value: getPriceLabel(lopt.price) }]'
        )

    v-card
      v-card-text
        v-layout.flex-column-phablet(justify-space-between, align-center)
          v-switch.ml-2(
            :label='lopt.enabled ? "Ingeschakeld" : "Uitgeschakeld"',
            v-model='lopt.enabled',
            style='max-width: 150px',
            color='primary'
            )

        v-divider.mb-4

        p Bied de aanvrager ook de mogelijkheid om interesse te tonen voor een #[span.lowercase {{ lopt.label }}]. Deze aanvraag kunt u terugvinden onder "Alle aanvragen". Deze aanvraag zou je zelf kunnen behandelen of kunnen doorverkopen als lead.

</template>

<script>
import { leaseOptionsAll } from 'dealerfinanceservices-shared/src/helpers/constants'
import currencyFilter from 'dealerfinanceservices-shared/src/filters/currency'

export default {
  props: {
    value: Array,
    productType: String
  },

  components: {
    PricingDialog: require('@/components/PricingDialog').default
  },

  data () {
    return {
      leaseOptionsForProductType: []
    }
  },

  computed: {
    isNew () {
      return this.$route.params.websiteId === 'new'
    }
  },

  methods: {
    getPriceLabel (n) {
      return !n ? 'Gratis' : currencyFilter(n)
    },

    init () {
      this.leaseOptionsForProductType = leaseOptionsAll.filter(lopt => lopt.productType === null || lopt.productType.includes(this.productType))

      // Set existing option to enabled if website has them. Ignore leaseOptions that the website has but no longer exist, they will disappear automatically
      this.leaseOptionsForProductType.forEach(x => {
        const existing = this.value ? this.value.find(y => y.name === x.name) : null

        if (existing) {
          this.$set(x, 'enabled', existing.enabled)
        } else if (this.isNew) {
          this.$set(x, 'enabled', x.defaultEnabled)
        }
      })

      this.$watch('leaseOptionsForProductType', (v) => { // Must be after
        const leaseOptions = v.filter(x => x.enabled).map(x => {
          return {
            enabled: x.enabled,
            name: x.name,
            productType: this.productType
          }
        })

        this.$emit('input', leaseOptions)
      }, { deep: true })
    }
  },

  created () {
    this.init()
  },

  watch: {
    productType (v) {
      this.init()
    }
  }
}
</script>
